// Front month constants -- update manually at contract expiry
const FRONT_MONTH_MNQ = 'MNQU6';
const FRONT_MONTH_NQ = 'NQU6';

export function formatInstrument(symbol: string | null | undefined): string {
  if (!symbol) return symbol ?? '';
  const s = String(symbol).toUpperCase().trim();
  if (s === 'MNQ' || s === 'MNQU6') return FRONT_MONTH_MNQ;
  if (s === 'NQ' || s === 'NQ1!' || s === 'NQU6') return FRONT_MONTH_NQ;
  return symbol;
}

export function rootSymbol(symbol: string | null | undefined): string {
  if (!symbol) return symbol ?? '';
  const s = String(symbol).toUpperCase().trim();
  if (s.startsWith('MNQ')) return 'MNQ';
  if (s.startsWith('NQ')) return 'NQ';
  return symbol;
}
